const checkboxes = [
  {
    name: 'ABC News',
    key: 'abc-news',
    val: 'abc-news',
    label: 'ABC News',
  },
  {
    name: 'BBC News',
    key: 'bbc-news',
    val: 'bbc-news',
    label: 'BBC News',
  },
  {
    name: 'BBC Sport',
    key: 'bbc-sport',
    val: 'bbc-sport',
    label: 'BBC Sport',
  },
  {
    name: 'Business Insider',
    key: 'business-insider',
    val: 'business-insider',
    label: 'Business Insider',
  },
  {
    name: 'BuzzFeed',
    key: 'buzzfeed',
    val: 'buzzfeed',
    label: 'BuzzFeed',
  },
  {
    name: 'CBC News',
    key: 'cbc-news',
    val: 'cbc-news',
    label: 'CBC News',
  },
  {
    name: 'CNBC',
    key: 'cnbc',
    val: 'cnbc',
    label: 'CNBC',
  },
  {
    name: 'CNN',
    key: 'cnn',
    val: 'cnn',
    label: 'CNN',
  },
  {
    name: 'Daily Mail',
    key: 'daily-mail',
    val: 'daily-mail',
    label: 'Daily Mail',
  },
  {
    name: 'The New York Times',
    key: 'the-new-york-times',
    val: 'the-new-york-times',
    label: 'The New York Times',
  },
  {
    name: 'The Washington Post',
    key: 'the-washington-post',
    val: 'the-washington-post',
    label: 'The Washington Post',
  },
  {
    name: 'The Washington Times',
    key: 'the-washington-times',
    val: 'the-washington-times',
    label: 'The Washington Times',
  }
];

export default checkboxes;